import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
    {
        description: 'Cor',
        path: '/biblioteca/bibcor',
        name: 'bibcor',
        component: () => import('@/views/biblioteca/bibcor/Index.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_CLASSIFICACAOPORCORNOVO_MENU_1300800499],
        },
        goesToMenu: true,
    },
    {
        description: 'Cadastro de Cores',
        path: '/biblioteca/bibcor/cadastro/:id?',
        parent: 'bibcor',
        name: 'bibcor_create',
        component: () => import('@/views/biblioteca/bibcor/InclusaoEdicao.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_CLASSIFICACAOPORCORNOVO_MENU_1300800499],
        },
        goesToMenu: true,
    },
]
